import { Avatar, Card, Col, Flex, Typography } from 'antd'

import { AddCircle } from 'iconsax-react'

import { useTranslation } from 'react-i18next'

import { useStyle } from './styles'

const { Text, Title } = Typography

type Props = {
  onOpenModal: () => void
}

export const CreateApplicationCard = ({ onOpenModal }: Props) => {
  const { t } = useTranslation()
  const { styles } = useStyle()

  return (
    <Col xs={24} sm={12} md={12} lg={8} xl={6} onClick={onOpenModal}>
      <Card className={styles.card} hoverable>
        <Flex vertical align="center" justify="center" gap={10}>
          <Avatar
            size={64}
            className={styles.avatar}
            src={<AddCircle size="32" />}
          />

          <Flex vertical align="center">
            <Title level={5}>{t('application.add')}</Title>
            <Text type="secondary">{t('application.discover')}</Text>
          </Flex>
        </Flex>
      </Card>
    </Col>
  )
}
